class UnknownUrlError extends Error {
    constructor(url) {
        super(`Unknown URL: ${url}`);
    }
}
export default UnknownUrlError;
